import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHarmonicLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			rx: 8,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.24072 2.58435L8.58595 3.93836V6.64638L6.24072 8.00039L3.89551 6.64638V3.93836L6.24072 2.58435Z",
			fill: "#FE5D45"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.24072 7.99956L8.58595 9.35357V12.0616L6.24072 13.4156L3.89551 12.0616V9.35357L6.24072 7.99956Z",
			fill: "#FE5D45"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.9349 5.29195L13.2801 6.64598V9.35397L10.9349 10.708L8.58964 9.35397V6.64598L10.9349 5.29195Z",
			fill: "#FE5D45"
		})
	]
});
export default SvgHarmonicLogo;
